import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=0ee821a8"
import script from "./StudentList.vue?vue&type=script&lang=ts"
export * from "./StudentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports